import React from 'react';
import Container from "../Wrappers/Container";
import SearchInput from "../Atoms/Forms/SearchInput";
import DropdownButton from "../Molecules/Dropsdown/DropdownButton";
import DropdownItem from "../Atoms/Items/DropdownItem";
import SidebarEmployee from "../Molecules/SidebarEmployee";
import {employeesTest} from "../../helpers/employees-test";

const EmployeesPanel = () => {
  return (
    <Container className="sticky-element s-h-vh">
      <header className="s-mb-16px m-mb-24px s-cross-center s-main-justify">
        <h4 className="s-mb-0">Empleados</h4>
        <div className="flex">
          {/* Botón para ordernar*/}
          <DropdownButton className="s-mr-12px" icon="order">
            <DropdownItem text="Id" isActive />
            <DropdownItem text="Nombre"/>
            <DropdownItem text="Estado"/>
          </DropdownButton>

          {/* Botón para filtrar*/}
          <DropdownButton icon="filter">
            <DropdownItem text="Tipo" isActive />
            <DropdownItem text="Estado"/>
            <DropdownItem text="Paso actual"/>
          </DropdownButton>
        </div>
      </header>
      <SearchInput placeholder="Busca por nombre o cédula" className="s-mb-16px m-mb-24px"/>
      <button className="button full s-mb-16px m-mb-24px">Agrega un nuevo empleado</button>

      <div className="ed-grid row-gap s-gap-1">
        {employeesTest.map(employee=> (
          <SidebarEmployee
            isActive={employee.id === 2}
            key={employee.identification_number}
            employee={employee}
          />
        ))}
      </div>
    </Container>
  );
};

export default EmployeesPanel;
